export const stripOrigin = (url) => {
  const v = new URL(url);
  return v.pathname + v.search + v.hash;
};
